export default {
    EPUB:'ePub',
    PDF:'pdf'
};